import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-0 flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "h-16 flex items-center px-6 border-b border-border shrink-0 bg-background" }
const _hoisted_3 = { class: "flex-1 overflow-auto p-6 lg:p-8" }
const _hoisted_4 = { class: "mt-8 max-w-2xl" }
const _hoisted_5 = { class: "upload-card bg-card border border-border p-6 shadow-sm" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_8 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_9 = { class: "flex items-center gap-3" }
const _hoisted_10 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_11 = { class: "mt-6 flex items-center gap-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "!text-xs !leading-4 text-muted-foreground" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_upload_type_drop_down = _resolveComponent("upload-type-drop-down")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_upload_page_progress = _resolveComponent("upload-page-progress")!
  const _component_upload_box = _resolveComponent("upload-box")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_title_text = _resolveComponent("title-text")!
  const _component_gray_text = _resolveComponent("gray-text")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "upload-icon-btn lg:hidden mr-3 p-2 hover:bg-accent text-foreground transition-colors",
            "aria-label": "Open menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "h-5 w-5",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M4 5h16" }),
              _createElementVNode("path", { d: "M4 12h16" }),
              _createElementVNode("path", { d: "M4 19h16" })
            ], -1)
          ]))]),
          _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "!text-xl !font-bold !leading-7 text-foreground" }, "Bulk Behaviors", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "!text-sm !leading-5 text-muted-foreground" }, " Perform batch operations on engagements and partner data. ", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "!text-base !font-semibold !leading-6 text-foreground flex items-center gap-2" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "h-[18px] w-[18px] text-sidebar-active",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
                  _createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
                  _createElementVNode("path", { d: "M12 12v6" }),
                  _createElementVNode("path", { d: "m15 15-3-3-3 3" })
                ]),
                _createTextVNode(" Data Operations ")
              ], -1)),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mt-1 !text-sm !leading-5 text-muted-foreground" }, " Select an action and upload the required file to proceed. ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block !text-sm !font-medium !leading-none text-foreground mb-1.5" }, "Select Behavior", -1)),
                _createVNode(_component_upload_type_drop_down, {
                  type: _ctx.uploadType,
                  label: _ctx.uploadLabel,
                  "have-permission-to-download": _ctx.havePermissionToDownload,
                  onOnTypeChange: _ctx.uploadTypeIsChanged
                }, null, 8, ["type", "label", "have-permission-to-download", "onOnTypeChange"])
              ]),
              (_ctx.uploadType === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.isAllPartnerDataDownloading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_ProgressBar, { progress: _ctx.downloadProgress }, null, 8, ["progress"]),
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-sm text-muted-foreground" }, "Generate and Download in progress...", -1))
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "upload-outline-btn px-4 py-2 text-sm border border-border text-foreground hover:bg-accent transition-colors",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abortDownload && _ctx.abortDownload(...args)))
                          }, " Cancel download ")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.uploadType !== 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block !text-sm !font-medium !leading-none text-foreground mb-1.5" }, "Upload File", -1)),
                    (_ctx.fileStatus)
                      ? (_openBlock(), _createBlock(_component_upload_page_progress, {
                          key: 0,
                          "percent-progress": _ctx.percentProgress,
                          state: _ctx.fileStatus.state || undefined
                        }, null, 8, ["percent-progress", "state"]))
                      : (_openBlock(), _createBlock(_component_upload_box, {
                          key: 1,
                          variant: "bulk",
                          onOnChosen: _ctx.onFileChosen
                        }, null, 8, ["onOnChosen"]))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "upload-execute-btn px-5 py-2.5 bg-sidebar-active text-white text-sm font-medium transition-colors hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed",
                  disabled: _ctx.uploadType !== 3 || _ctx.isAllPartnerDataDownloading,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadAllPartnerData && _ctx.downloadAllPartnerData(...args)))
                }, " Execute ", 8, _hoisted_12),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.executeHint), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.uploadCompletedModal.isOpen.value,
        onOnCancel: _ctx.uploadCompletedModal.close,
        onOnConfirm: _ctx.uploadCompletedModal.close
      }, {
        content: _withCtx(() => [...(_cache[16] || (_cache[16] = [
          _createElementVNode("p", { class: "text-center" }, "Upload Successfully Complete.", -1)
        ]))]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("Back to Dashboard", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.errorModal.isOpen.value
      }, {
        content: _withCtx(() => [
          _createVNode(_component_title_text, null, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("Your upload is failed!", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "red",
            onClick: _ctx.errorModal.close
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode("Try Again", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'dashboard'})))
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode(" Back to Dashboard ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-visible"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmDeleteFilesModal.isOpen.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_title_text, null, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("This will delete all data", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_gray_text, null, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode("'Type DELETE' to remove all data", -1)
              ]))]),
              _: 1
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.deleteValue) = $event)),
              class: "input-confirm-delete",
              type: "text",
              placeholder: "DELETE"
            }, null, 512), [
              [_vModelText, _ctx.deleteValue]
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "red",
            disabled: _ctx.confirmDeleteFilesConfirmButtonDisabled,
            onClick: _ctx.importAndReplace
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("Delete data", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            disabled: true,
            onClick: _ctx.handleConfirmDeleteFilesModalClose
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible"]),
      _createVNode(_component_confirm_delete_modal, {
        "is-open": _ctx.confirmDeleteDataAndImportNewModal.isOpen.value,
        title: "Are you sure you want to delete all data and import new data?",
        subtitle: "Type delete to  confirm action",
        "confirm-button-text": "Delete all data and import new data",
        onOnConfirm: _ctx.confirmDeleteDataAndImportNewModalSecondModal.open,
        onOnCancel: _ctx.confirmDeleteDataAndImportNewModal.close
      }, null, 8, ["is-open", "onOnConfirm", "onOnCancel"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmDeleteDataAndImportNewModalSecondModal.isOpen.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_title_text, null, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("This will delete all data and import new data", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "red",
            onClick: _cache[6] || (_cache[6] = () => {
            _ctx.uploadType = 2;
            _ctx.confirmDeleteDataAndImportNewModalSecondModal.close();
            _ctx.confirmDeleteDataAndImportNewModal.close();
          })
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode("Confirm", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_base_button, {
            class: "mx-1",
            variant: "outlined",
            disabled: false,
            onClick: _cache[7] || (_cache[7] = () => {
            _ctx.confirmDeleteDataAndImportNewModalSecondModal.close();
            _ctx.confirmDeleteDataAndImportNewModal.close();
          })
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-visible"])
    ]),
    _: 1
  }))
}